import React, { useState, useEffect } from "react";
import AdminPanel from "../panel/AdminPanel";
import api from "../../../api/api";
import { FaUserPlus, FaTrash } from "react-icons/fa";
import "../styles/AssignTeacher.css";


const AssignTeacher = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const [teachers, setTeachers] = useState([]);
  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);

  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedTeacher, setSelectedTeacher] = useState("");

  useEffect(() => {
    fetchTeachers();
    fetchClasses();
  }, []);

  const fetchTeachers = async () => {
    try {
      const res = await api.get("/api/teachers");
      setTeachers(res.data); // [{id, name}]
    } catch (err) {
      console.error("Error fetching teachers:", err);
    }
  };

  const fetchClasses = async () => {
    try {
     const res = await api.get("/api/classes-with-subjects");
      setClasses(res.data); // [{id, name, subjects: [], teacherAssignments: []}]
    } catch (err) {
      console.error("Error fetching classes:", err);
    }
  };

  const fetchSections = async (classId) => {
    try {
      const res = await api.get("/api/sections", { params: { classId } });
      setSections(res.data); // [{id, name}]
    } catch (err) {
      console.error("Error fetching sections:", err);
    }
  };

  const handleClassChange = (e) => {
    const classId = e.target.value;
    setSelectedClass(classId);
    setSelectedSection("");
    setSelectedSubject("");
    setSections([]);

    if (classId) fetchSections(classId);
  };

  const assignTeacher = async () => {
    if (!selectedClass || !selectedSection || !selectedSubject || !selectedTeacher) return;

    try {
      await api.post("/api/assign/teacher", {
        classId: Number(selectedClass),
        sectionId: Number(selectedSection),
        subject: selectedSubject,
        teacherId: Number(selectedTeacher),
      });
      alert("✅ Teacher assigned successfully!");
      setSelectedClass("");
      setSelectedSection("");
      setSelectedSubject("");
      setSelectedTeacher("");
      setSections([]);
      fetchClasses(); // refresh assignments
    } catch (err) {
      console.error("Error assigning teacher:", err);
      alert("❌ Could not assign teacher.");
    }
  };

const removeTeacher = async (classId, subject, sectionId) => {
  try {
    await api.delete("/api/assign/teacher", {
      data: { classId, subject, sectionId },
    });
    fetchClasses(); // refresh assignments
  } catch (err) {
    console.error("Error removing teacher:", err);
    alert("❌ Could not remove teacher.");
  }
};

  return (
    <>
      <AdminPanel onToggle={setIsSidebarCollapsed} />
      <div className={`assign-teacher-container ${isSidebarCollapsed ? "collapsed" : ""}`}>
        <h2>Assign Teachers to Classes</h2>

        {/* Assignment Form */}
        <div className="assign-teacher-card">
          <h3><FaUserPlus style={{ marginRight: "8px" }} /> Assign Teacher</h3>
          <div className="assign-teacher-form">
            {/* Class Dropdown */}
            <select value={selectedClass} onChange={handleClassChange}>
              <option value="">Select Class</option>
              {classes.map((c) => (
                <option key={c.id} value={c.id}>{c.name}</option>
              ))}
            </select>

            {/* Section Dropdown */}
            {selectedClass && sections.length > 0 && (
              <select value={selectedSection} onChange={(e) => setSelectedSection(e.target.value)}>
                <option value="">Select Section</option>
                {sections.map((sec) => (
                  <option key={sec.id} value={sec.id}>{sec.name}</option>
                ))}
              </select>
            )}

            {/* Subject Dropdown */}
            {selectedClass && (
              <select value={selectedSubject} onChange={(e) => setSelectedSubject(e.target.value)}>
                <option value="">Select Subject</option>
                {classes.find(c => c.id === parseInt(selectedClass))?.subjects.map((subj, idx) => (
                  <option key={idx} value={subj}>{subj}</option>
                ))}
              </select>
            )}

            {/* Teacher Dropdown */}
            <select value={selectedTeacher} onChange={(e) => setSelectedTeacher(e.target.value)}>
              <option value="">Select Teacher</option>
              {teachers.map((t) => (
                <option key={t.id} value={t.id}>{t.name}</option>
              ))}
            </select>

            <button onClick={assignTeacher}>Assign</button>
          </div>
        </div>

{/* Existing Assignments */}
<div className="assignment-table-card">
  <h3>Existing Class Assignments</h3>
  <table>
    <thead>
      <tr>
        <th>Class</th>
        <th>Section</th>
        <th>Subject</th>
        <th>Teacher</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      {classes.map((c) =>
        c.teacherAssignments?.map((a, idx) => (
          <tr key={`${c.id}-${idx}`}>
            <td>{c.name}</td>
            <td>{a.section?.name || "-"}</td>
            <td>{a.subject}</td>
            <td>{a.teacher.name}</td>
            <td>
              <button
                className="delete-btn"
                onClick={() => removeTeacher(c.id, a.subject, a.section?.id)}
              >
                <FaTrash /> Remove
              </button>
            </td>
          </tr>
        ))
      )}
    </tbody>
  </table>
</div>

      </div>
    </>
  );
};

export default AssignTeacher;
